import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConditionalPrice } from '../../../../../model/sign/conditional-price';

@Component({
  selector: 'conditional-price',
  templateUrl: './conditional-price.component.html',
  styleUrls: ['./conditional-price.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConditionalPriceComponent),
      multi: true,
    },
  ],
})
export class ConditionalPriceComponent implements ControlValueAccessor {
  @Input()
  _value: ConditionalPrice;
  @Input()
  booleanLabel: string;
  @Input()
  priceLabel: string = 'Prijs / stuk';
  @Input()
  placeholder: string = '';
  @Input()
  inputFieldStyle: any;
  @Input()
  labelStyle: any;
  onChange: any = () => {};
  onTouch: any = () => {};

  constructor() {}

  get value() {
    return this._value;
  }

  set value(val: ConditionalPrice) {
    this._value = val;
    this.onChange(val);
    this.onTouch(val);
  }

  writeValue(value: ConditionalPrice): void {
    if (value) {
      this._value = value;
    } else {
      this._value = new ConditionalPrice();
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  onBooleanValueChanged(): void {
    this.onChange(this._value);
    this.onTouch(this._value);
  }
}
